import { panelLabelAnswerAI } from "_constants";
import { Answer } from "interfaces";
import { SourceTypeChipContainer } from "./SourceTypeChipContainer";
import { ReactMarkdownAI } from "components/shared";

export const ReportAnswerContainer = ({ answer }: { answer: Answer }) => {
  return (
    <div className="answer-container">
      <span className="blue-text font-weight-700 margin-bottom-8">
        {panelLabelAnswerAI}
      </span>

      <div className="margin-top-8 margin-bottom-36">
        <ReactMarkdownAI message={answer.message?.replace(/\n/g, "  \n  ")} />
      </div>
      {answer && <SourceTypeChipContainer answer={answer} />}
    </div>
  );
};
